export enum FiltroTicketEnum {
    NOMBRE = 'NOMBRE',
    FECHA = 'FECHA',
    NÚMERO = 'NÚMERO'
}

export class FiltroTicketDTO {
    nombre: boolean;
    fecha: boolean;
    numero: boolean;

    constructor() {
        this.nombre = false;
        this.fecha = false;
        this.numero = false;
    }

}
